// tslint:disable:quotemark
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
// @ts-ignore
import * as apparelSorter from "../../helpers/apparel-sorter";

import { getImagesFromProductByVariant } from "../../helpers/getImagesFromProductByVariant";
import {
  Button,
  FlashMessage,
  Icon,
  Modal,
  Popover,
  Svg,
  BuyButton,
  InquiryButton,
  VariantSlider,
  AvailabilityWatchFormButton,
} from "../../modules/modules";
import CartService from "../../services/CartService";
import { CurrencyFormatter } from "../../utils/utils";

import {
  canProductInquiry,
  canProductBuy,
  canDisplayProductPrice,
} from "../../helpers/products";
import { buildProductLink } from "../../pages/ProductDetail/ProductDetailPage";
import { canSaveCookie } from "../../helpers/cookies/canSaveCookies";
import { getVisitorToken } from "../../helpers/cookies/getVisitorToken";
import { findFinalPrice, findPrice } from "../../helpers/prices";
import CountryService from "../../services/CountryService";

import ImageGallery from "./components/ImageGallery";
import VariantSelector from "./components/VariantSelector";
import WeightDisplay from "../WeightDisplay";
import { vatDescription } from "../../helpers/vatDescription";
import { showWatchDogButtonAvailabilityFlag } from "helpers/src/availability/watchDogActions";

export interface IVariantSizePair {
  variant: GQL.IProductVariant;
  size: any;
}

interface IProductDetailState {
  showModal: boolean;
  flashMessage: boolean;
  selectedVariantId: string | undefined;
  selectedSizeVariant: string | undefined;
  highlightMessage: boolean;
  chartTab: number;
  chartModal: boolean;
  magnifier: boolean;
  quantity: number;
}

interface IProductDetailProps
  extends RouteComponentProps<{ language: string; slug: string }> {
  variant: any;
  availableSizeVariants: Array<IVariantSizePair>;
  isFavorite: boolean;
  toggleFavorite: (variantId: string) => void;

  category: GQL.ICategory | undefined;

  sell: boolean;
  createLastVisited: (args: any) => void;
  setCurrentProductAvailabityWatchdogForm?: (
    product?: GQL.IProduct,
    variant?: GQL.IProductVariant
  ) => void;
}

function createMarkup(content: string) {
  return {
    __html:
      "<p>" +
      (content ? content.replace(/(?:\r\n|\r|\n)/g, "</p><p>") : "") +
      "</p>",
  };
}

class ProductDetail extends React.Component<
  IProductDetailProps,
  IProductDetailState
> {
  private _mounted = false;

  constructor(props: IProductDetailProps) {
    super(props);

    this.state = {
      flashMessage: false,
      showModal: false,
      selectedVariantId: undefined,
      selectedSizeVariant: undefined,
      highlightMessage: false,
      chartTab: 0,
      chartModal: false,
      magnifier: false,
      quantity: 1,
    };

    this.addToCart = this.addToCart.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.toggleChartModal = this.toggleChartModal.bind(this);
    this.closeFlashMessage = this.closeFlashMessage.bind(this);
    this.onChangeSelectedSizeVariant = this.onChangeSelectedSizeVariant.bind(
      this
    );
    this.toggleMagnifier = this.toggleMagnifier.bind(this);
    this.onChangeVariant = this.onChangeVariant.bind(this);
    this.onChangeQuantity = this.onChangeQuantity.bind(this);
  }

  public componentWillMount() {
    // zaznamenám poslední zobrazení
    if (this.props.variant && this.props.createLastVisited && canSaveCookie()) {
      this.props.createLastVisited({
        variables: {
          lastVisited: {
            userToken: getVisitorToken(),
            productId: this.props.variant.product.id,
            variantId: this.props.variant.id,
          },
        },
      });
    }
  }

  public addToCart() {
    const variantId = this.state.selectedVariantId;
    if (variantId) {
      // CartService.GetInstance().addToCart(variantId);
      // this.setState({ showModal: true, flashMessage: true, highlightMessage: false });
    } else if (this.props.availableSizeVariants.length == 0) {
      CartService.GetInstance().addToCart(
        this.props.variant,
        { GTMItemListName: this.props.location.state && this.props.location.state.GTMItemListName || undefined },
        this.state.quantity
      );
      this.setState({
        showModal: true,
        flashMessage: true,
        highlightMessage: false,
      });
    } else {
      this.setState({ highlightMessage: true });
    }
  }

  public closeModal() {
    this.setState({ showModal: false });
  }
  public toggleChartModal(open: boolean) {
    this.setState({ chartModal: open });
  }

  public setChartTab(num: number) {
    this.setState({ chartTab: num });
  }

  public componentDidMount() {
    this._mounted = true;
  }

  public componentWillUnmount() {
    this._mounted = false;
  }

  public closeFlashMessage() {
    if (this._mounted) {
      this.setState({ flashMessage: false });
    }
  }

  private onChangeSelectedSizeVariant(variant: any) {
    this.setState({
      selectedSizeVariant: variant.value,
    });
  }

  private toggleMagnifier() {
    this.setState({ magnifier: !this.state.magnifier });
  }

  private getPrice() {
    return findFinalPrice(this.props.variant);
  }

  private getPriceWithVat() {
    const { VATrate } = CountryService.GetInstance();

    return findFinalPrice(this.props.variant, false, VATrate);
  }

  private getRecommendedPrice() {
    return findFinalPrice(this.props.variant, true);
  }

  private getRecommendedPriceWithVat() {
    const { VATrate } = CountryService.GetInstance();

    return findFinalPrice(this.props.variant, true, VATrate);
  }

  public render() {
    const { language, VATrate } = CountryService.GetInstance();
    const { variant } = this.props;
    const { product } = variant;
    const images = getImagesFromProductByVariant(product, variant);
    const watchDogButtonFor =
      "string" ===
      typeof process.env
        .REACT_APP_SHOW_AVAILABILITY_WATCH_FORM_FOR_PRODUCTS_WITH_AVAILABILITYIDS
        ? process.env.REACT_APP_SHOW_AVAILABILITY_WATCH_FORM_FOR_PRODUCTS_WITH_AVAILABILITYIDS.split(
            ","
          ).map((a) => a.trim())
        : [];

    const showWatchDogButton =
      product &&
      product.availability &&
      "string" === typeof product.availability.id
        ? 0 <= watchDogButtonFor.indexOf(product.availability.id) ||
          showWatchDogButtonAvailabilityFlag ===
            (product.availability as any).watchDogAction
        : false;

    // const colorSiblings = filterProducts(
    //     [product], {}, [],
    //     p => p, vs => {
    //         return vs.filter(v => v.inStock > 0 || product.status != 3);
    //     }, []
    // );

    const hasSubtitle = product.subtitle && 'string' === typeof product.subtitle[language] && product.subtitle[language].trim().length > 0;

    return (
      <div className="productDetail">
        <div className="row">
          <div className="col-12 col-lg-6">
            <ImageGallery images={images} variant={variant} />
          </div>

          <div className="col-12 col-lg-6 productDetail__overview">
            <h1 className={`productDetail__title${hasSubtitle ? ' with-subtitle' : ''}`}>{product.name[language]}</h1>
            {hasSubtitle && <h2 className="productDetail__title">{product.subtitle[language]}</h2> || ''}

            <div
              className="productDetail__perex"
              dangerouslySetInnerHTML={createMarkup(product.perex[language])}
            />

            <VariantSelector
              name={"variant"}
              className={"productDetail__variant"}
              variant={variant}
              onChange={this.onChangeVariant}
            />

            <div
              className={`productDetail__infoTable${
                !canDisplayProductPrice(product) ? " cannotBuy" : ""
              }`}
            >
              <div className="row">
                <div className="col-12 col-sm-6">
                  <div className="data">
                    <div className="productDetail__infoTable__row">
                      <span>Item number :</span>#{variant.sku}
                    </div>
                    <div className="productDetail__infoTable__row">
                      <span>Item weight :</span>
                      <WeightDisplay weight={product.weight} />
                    </div>
                    <div className="productDetail__infoTable__row">
                      <span>Availability :</span>
                      {product.availability && (
                        <strong style={{ color: product.availability.color }}>
                          {product.availability.title[language]}
                        </strong>
                      )}
                    </div>
                  </div>
                </div>
                {canDisplayProductPrice(product) && (
                  <div className="col-12 col-sm-6 counts d-flex align-items-center">
                    <div className="full-width">
                      {(showWatchDogButton && false && <>&nbsp;</>) || (
                        <div className="row">
                          <div className="col-6 text-right">
                            <BuyButton
                              product={product}
                              variant={variant}
                              mode={"simple"}
                              quantity={this.state.quantity}
                              onChange={this.onChangeQuantity}
                            />
                          </div>
                          <div className="col-6 text-left">
                            <div className="productDetail__price-description">
                              count of pcs
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="productDetail__price">
              <div className="row">
                {canDisplayProductPrice(product) && (
                  <div className="col-sm-6">
                    <div className="text-center">
                      <span className="recommendedPrice">
                        {this.getRecommendedPriceWithVat() >
                          this.getPriceWithVat() && (
                          <CurrencyFormatter
                            price={this.getRecommendedPrice()}
                          />
                        )}
                      </span>
                      <span className="price">
                        <strong>
                          <CurrencyFormatter
                              price={this.getPrice()}
                              decimals={2}
                            />
                        </strong>
                        <br />
                        {VATrate > 0 && (
                          <em>
                            <CurrencyFormatter price={this.getPriceWithVat()} />{" "}
                            incl. {vatDescription()}
                          </em>
                        )}
                      </span>
                    </div>
                  </div>
                )}
                <div
                  className={`col-sm-${
                    canDisplayProductPrice(product) ? "6" : "12"
                  } d-flex watchdog-add-wrapper`}
                >
                  {canProductInquiry(product) && (
                    <InquiryButton
                      type={"detail"}
                      product={product}
                      variant={variant}
                    />
                  )}

                  {!canProductInquiry(product) && (
                    <>
                      <Button
                        type="toCart"
                        className={
                          this.state.selectedVariantId ||
                          this.props.availableSizeVariants.length == 0
                            ? ""
                            : "isDisabled"
                        }
                        disabled={!canProductBuy(product) || showWatchDogButton}
                        onClick={this.addToCart}
                      >
                        <Svg name="basket" />
                        Add to cart
                      </Button>
                      {(showWatchDogButton && (
                        <AvailabilityWatchFormButton
                          product={product}
                          variant={variant}
                          whereOpened="product-detail"
                          setCurrentProductAvailabityWatchdogForm={
                            this.props.setCurrentProductAvailabityWatchdogForm
                          }
                        />
                      )) ||
                        ""}
                    </>
                  )}
                </div>
              </div>
            </div>

            {this.state.showModal && (
              <div className="">
                <Modal
                  type={"toCart"}
                  language={language}
                  variant={variant}
                  onClose={this.closeModal}
                  open={this.state.showModal}
                  quantity={this.state.quantity}
                />
              </div>
            )}
          </div>

          {/* <FlashMessage
              type="toCart"
              link={`/${countryCode}/cart`}
              visible={this.state.flashMessage}
              onTimeout={this.closeFlashMessage}
            >
              Úspěšně přidáno do košíku
            </FlashMessage> */}
        </div>
      </div>
    );
  }

  private sortSizes(
    sizes: Array<IVariantSizePair>,
    variant: string | undefined
  ) {
    if (!Array.isArray(sizes) || sizes.length === 0) {
      return sizes;
    }

    const currentVariant =
      variant ||
      (sizes &&
        Array.isArray(sizes) &&
        sizes[0].size.sizesVariants &&
        sizes[0].size.sizesVariants[0]);

    return sizes.sort((a: IVariantSizePair, b: IVariantSizePair) => {
      if (
        a.size.availableSizes === undefined ||
        b.size.availableSizes === undefined
      ) {
        return 0;
      }

      const aIndex =
        (currentVariant &&
          apparelSorter.sizeIndex(a.size.availableSizes[currentVariant])) ||
        apparelSorter.sizeIndex(a.size.availableSizes);
      const bIndex =
        (currentVariant &&
          apparelSorter.sizeIndex(b.size.availableSizes[currentVariant])) ||
        apparelSorter.sizeIndex(b.size.availableSizes);
      return aIndex < bIndex ? -1 : 1;
    });
  }

  private redirectToVariant(product: GQL.IProduct, v: GQL.IProductVariant) {
    const { language } = CountryService.GetInstance();
    const productLink = buildProductLink(
      product,
      this.props.category,
      v,
      language
    );
    this.props.history.push(`${productLink}`);
  }

  private onChangeVariant(variant: GQL.IProductVariant) {
    this.redirectToVariant(this.props.variant.product, variant);
  }

  private onChangeQuantity(quantity: number) {
    this.setState({
      quantity,
    });
  }
}

export default withRouter(ProductDetail);



// WEBPACK FOOTER //
// ./src/components/ProductDetail/ProductDetail.tsx